var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row align-items-center"},[_c('div',[_c('span',{class:[_vm.status.toLowerCase(), 'status-circle', 'mr-2']})]),_c('div',[_c('order-status',{attrs:{"status":_vm.status}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }